import * as runtimeConfig from 'constants/runtimeConfig';

export const COUPONS = '/api/coupons';
export const LOGIN = '/api/auth/login';
export const LOGOUT = '/api/auth/logout';

export const ACCOUNT_SETTINGS = '/account-settings';
export const MANAGE_WORKSPACE = '/settings/workspace';
export const MANAGE_PLANS = '/settings/workspace#plans';
export const MANAGE_INTEGRATIONS = '/settings/workspace#integrations';
export const SETTINGS = '/settings';
export const PROFILE = '/settings/account';
export const ACTIVITY_FEED = '/activity-feed';
export const ARCHIVED = '/archived';
export const COMPANY = '/about-us';
export const CAREERS = '/careers';
export const CUSTOMERS_PAGE = '/customers';
export const DESKTOP = '/desktop';
export const DOWNLOAD_PAGE = '/download';
export const ADMIN_PAGE = '/admin';
export const EMBED_VIDEO = '/embed';
export const FAVORITES_PAGE = '/favorites';
export const WATCH_LATER_PAGE = '/watch-later';
export const HUMAN_PRIVACY = '/privacy';
export const INTEGRATIONS_PAGE = '/integrations';
export const LOGOUT_PAGE = '/logout';
export const LOGIN_PAGE = '/login';
export const LOGIN_WITH_SSO_PAGE = '/login/sso';
export const SIGNUP_PAGE = '/signup';
export const MY_VIDEOS_PAGE = '/my-videos';
export const NOTIFICATIONS_PAGE = '/notifications';
export const PROFILE_PAGE = '/settings/account';
export const REQUEST_TO_JOIN_PAGE = '/request-to-join';
export const TEAM_VIDEOS_PAGE = '/team-videos';
export const SEARCH_PAGE = '/search';
export const SHARED_VIDEOS_PAGE = '/shared-videos';
export const NOT_FOUND = '/404';
export const PRICING = '/pricing';
export const PRIVACY_POLICY = '/privacy-policy';
export const ROOT_PAGE = '/';
export const SERVER_ERROR_PAGE = '/500';
export const TERMS = '/terms';
export const USE_CASES = '/use-case';
export const UPGRADE = '/upgrade';
export const WELCOME = '/welcome';
export const VERIFY_EMAIL = '/verify-email';
export const RESET_PASSWORD = '/reset-password';
export const PRESS = '/press';
export const SCIM = '/scim/v2';
export const RECORD = '/record';
export const SELECT_WORKSPACE_PAGE = '/select-workspace';
export const MANAGE_MEMBERS = `${MANAGE_WORKSPACE}#members`;
export const PLANS_AND_BILLING = `${MANAGE_WORKSPACE}#plans`;
export const RECOVER_VIDEOS_PAGE = `recover-videos`;
export const EDUCATION_PAGE = '/get-loom';
export const MY_VIDEOS_EDUCATION_PAGE = `${EDUCATION_PAGE}${MY_VIDEOS_PAGE}`;
export const SHARED_VIDEOS_EDUCATION_PAGE = `${EDUCATION_PAGE}${SHARED_VIDEOS_PAGE}`;
export const TEAM_VIDEOS_EDUCATION_PAGE = `${EDUCATION_PAGE}${TEAM_VIDEOS_PAGE}`;
export const FAVORITES_EDUCATION_PAGE = `${EDUCATION_PAGE}${FAVORITES_PAGE}`;
export const LOOMS_PAGE = '/looms';
export const VIDEOS_LOOMS_PAGE = '/looms/videos';
export const FOLDERS_LOOMS_PAGE = '/looms/folders';
export const ARCHIVED_LOOMS_PAGE = '/looms/archive';
export const SCREENSHOTS_PAGE = '/looms/screenshots';
export const HISTORY_PAGE = '/history';
export const EXPERIMENTATION_FRAMEWORK = `${ADMIN_PAGE}/experimentation`;
export const SSO_LOGIN = '/login/sso';

export const PUBLISHING_HELP_PAGE =
  'https://support.loom.com/hc/en-us/articles/4404238149405';
export const LOOM_FOR_TEAMS_URI =
  'https://www.loom.com/video-messaging-for-teams';
export const MOBILE_PAGE_URI = 'https://www.loom.com/mobile';
export const BLOG_URI = 'https://www.loom.com/blog';
export const CASE_STUDIES = 'https://www.loom.com/use-cases';
export const CLOUDFRONT_URI = `https://${runtimeConfig.CLOUDFRONT_URI}`;
export const AVSERVER_CLOUDFRONT_URI = `https://${runtimeConfig.AVSERVER_CLOUDFRONT_URI}`;
export const CHROME_EXT_WEBSTORE_URL = `https://chrome.google.com/webstore/detail/${runtimeConfig.CHROME_EXTENSION_ID}`;
export const LOOM_ANON_COOKIE_DOMAIN = runtimeConfig.ANON_COOKIE_DOMAIN;
export const LOOM_BARE_URI = runtimeConfig.LOOM_BARE_URI;
export const LOOM_PROD_URI = 'https://www.loom.com';
export const LOOM_STAGE_URI = 'https://stage.loom.com';
export const LOOM_DEV_URI = 'https://loomlocal.com';
export const LOOM_URI = `https://${runtimeConfig.LOOM_URI}`;
export const LOOM_WS_URI = `wss://${runtimeConfig.LOOM_URI}`;
export const LOOM_RECORD_WS_URI = `wss://${runtimeConfig.LOOM_RECORD_WS_URI}`;
export const SUPPORT_URI = 'http://support.loom.com';
export const NEW_LOOM_URI = 'https://new.loom.com';
export const STATUS_URI = 'https://www.loomstatus.com';

export const MOBILE_IOS_APP =
  'https://apps.apple.com/us/app/loom-screen-recordings-more/id1474480829';
export const MOBILE_ANDROID_APP =
  'https://play.google.com/store/apps/details?id=com.loom.android';
export const MOBILE_WEB = 'https://www.loom.com/mobile';

export const BETA_TAG_SUPPORT_ARTICLE = `${SUPPORT_URI}/faqs-and-troubleshooting/what-does-the-beta-tag-mean`;
export const COVID19_SUPPORT_ARTICLE = `${SUPPORT_URI}/hc/en-us/articles/360006638998-How-Loom-Can-Help-During-the-Coronavirus`;
export const FREE_FOR_EDU_SUPPORT_ARTICLE = `${SUPPORT_URI}/hc/en-us/articles/360006579637-Loom-Pro-Free-for-Students-and-Teachers`;
export const TRIMMING_SUPPORT_ARTICLE = `${SUPPORT_URI}/hc/en-us/articles/360002217478-Trim-your-Loom-video-`;
export const SUPPORT_MEMBER_ROLES = `${SUPPORT_URI}/hc/en-us/articles/360010394657-Understanding-Workspaces-and-Member-Roles`;

export const EXTENSION_RECORDING_SUPPORT_ARTICLE =
  'https://support.loom.com/hc/en-us/articles/360002187698-Getting-started-with-the-Chrome-Extension';
export const DESKTOP_RECORDING_SUPPORT_ARTICLE =
  'https://support.loom.com/hc/en-us/articles/360002207917-Getting-started-with-the-Desktop-App';

export const SHARE_RECORDING_SUPPORT_ARTICLE =
  'https://support.loom.com/hc/en-us/articles/360002208157-Share-your-recording';

export const UNDERSTANDING_PUBLISHED_VIDEOS_ARTICLE =
  'https://support.loom.com/hc/en-us/articles/4404238149405';

export const SYSTEM_REQ_ARTICLE = `${SUPPORT_URI}/loom-pro-desktop-app/make-sure-your-device-is-loom-pro-compatible`;

export const BILLING_FAQ_LINK =
  'https://support.loom.com/hc/en-us/articles/360002240877-Loom-Pro-general-FAQ';

export const LAUNCH_DESKTOP_URI = runtimeConfig.LOOM_DESKTOP_PROTOCOL;

export const WHATSNEW = 'https://new.loom.com/';
export const JOBS_LEVER = 'https://jobs.lever.co/useloom/';
export const PRODUCTBOARD = 'https://portal.productboard.com/useloom/';

export const APP_STORE =
  'https://apps.apple.com/us/app/loom-screen-recordings-more/id1474480829';

export const EI_HOW_WE_CALCULATE =
  'https://support.loom.com/hc/en-us/articles/360007980598-How-we-calculate-engagement-insights';

export const SLACK_INTEGRATION_URI =
  'https://support.loom.com/hc/en-us/articles/360002231278-Slack-Send-Loom-Videos-to-my-team-on-Slack';

export const CONTENT_TRANSFER_ARTICLE =
  'https://support.loom.com/hc/en-us/articles/360017747698';

export const EMBED_SUPPORT_ARTICLE =
  'https://support.loom.com/hc/en-us/articles/360002208317-How-to-embed-your-video-into-a-webpage-';
